import React from 'react';
import { Card } from 'primereact/card';
import { Divider } from 'primereact/divider';

import usePageTitle from '../../hooks/UsePageTitle';
const TaxAdvisory = () => {
  usePageTitle('Tax Advisory Services');

  return (
    <div className="page-container">
      <div className="grid">
        <div className="col-12">
          <h1 className="text-center">Tax Advisory Services</h1>
          <Divider />
        </div>

        {/* Introduction Section */}
        <div className="col-12 md:col-6">
          <img 
            src='/images/Tax Advisory Services.jpg' 
            alt="Tax Advisory Services" 
            className="w-full border-round shadow-2 mb-4" 
            style={{ maxHeight: '400px', objectFit: 'cover' }}
          />
        </div>
        <div className="col-12 md:col-6">
          <Card className="h-full">
            <p className="text-lg line-height-3">
              Taxes are more than a statutory obligation — they are strategic levers that can unlock financial efficiency, 
              investor confidence, and global readiness.
            </p>
            <p className="text-lg line-height-3 mt-3">
              At SnP Finvisors, our Tax Advisory Services are tailored to ensure compliance, reduce litigation, and optimize 
              tax positions for individuals, corporates, startups, and multinational groups.
            </p>
            <p className="text-lg line-height-3 mt-3 font-semibold">
              Our experts offer holistic and forward-looking tax strategies that adapt to regulatory shifts, emerging trends, 
              and unique business objectives.
            </p>
          </Card>
        </div>

        {/* Services Section */}
        <div className="col-12 mt-5">
          <h2>Our Tax Advisory Services</h2>
          <Divider />
          
          <div className="grid">
            {/* Service 1 */}
            <div className="col-12 md:col-6 ">
              <Card title="1. Income Tax Compliance & Litigation" className="mb-4">
                  <div className="col-12">
                    <p className="text-lg">
                      Navigating the Indian Income Tax framework can be complex, given frequent changes, digital scrutiny, 
                      and growing litigation. We assist in:
                    </p>
                    <ul className="list-none p-0 m-0">
                      <li className="mb-2 flex align-items-start">
                        <i className="pi pi-check-circle text-primary mr-2 mt-1"></i>
                        <span>Preparation and filing of corporate and individual income tax returns</span>
                      </li>
                      <li className="mb-2 flex align-items-start">
                        <i className="pi pi-check-circle text-primary mr-2 mt-1"></i>
                        <span>Advance tax computation, TDS reconciliations, and Form 26AS checks</span>
                      </li>
                      <li className="mb-2 flex align-items-start">
                        <i className="pi pi-check-circle text-primary mr-2 mt-1"></i>
                        <span>Representation before income tax authorities in scrutiny, reassessment, or penalty proceedings</span>
                      </li>
                      <li className="mb-2 flex align-items-start">
                        <i className="pi pi-check-circle text-primary mr-2 mt-1"></i>
                        <span>Drafting and filing of appeals before CIT(A), ITAT, and coordination with legal counsel</span>
                      </li>
                      <li className="mb-2 flex align-items-start">
                        <i className="pi pi-check-circle text-primary mr-2 mt-1"></i>
                        <span>Assessment of past tax positions and risk mitigation advice</span>
                      </li>
                      <li className="mb-4 flex align-items-start">
                        <i className="pi pi-check-circle text-primary mr-2 mt-1"></i>
                         Our litigation approach combines technical acumen with negotiation skills, aiming to resolve disputes 
                      efficiently while safeguarding client interests.
                      </li>
                    </ul>
                  </div>
              </Card>
            </div>

            {/* Service 2 */}
            <div className="col-12 md:col-6">
              <Card title="2. Tax Structuring & Tax Planning" className="h-full">
                <p className="text-lg">
                  Whether you're planning an investment, reorganisation, or cross-border transaction, smart structuring 
                  can reduce your tax outgo and future-proof your compliance.
                </p>
                <ul className="list-none p-0 m-0">
                  <li className="mb-2 flex align-items-start">
                    <i className="pi pi-check-circle text-primary mr-2 mt-1"></i>
                    <span>Designing tax-efficient business models for startups and corporates</span>
                  </li>
                  <li className="mb-2 flex align-items-start">
                    <i className="pi pi-check-circle text-primary mr-2 mt-1"></i>
                    <span>Capital gains planning, ESOP taxation, and bonus/dividend distribution strategies</span>
                  </li>
                  <li className="mb-2 flex align-items-start">
                    <i className="pi pi-check-circle text-primary mr-2 mt-1"></i>
                    <span>Inbound and outbound structuring for FDI, ODI, and foreign remittances</span>
                  </li>
                  <li className="flex align-items-start">
                    <i className="pi pi-check-circle text-primary mr-2 mt-1"></i>
                    <span>Planning for succession, family office set-ups, and HNI wealth structuring</span>
                  </li>
                </ul>
                <p className="text-lg mt-3 font-semibold">
                  Our team focuses on legality, transparency, and long-term sustainability of all planning efforts.
                </p>
              </Card>
            </div>

            {/* Service 3 */}
            <div className="col-12 md:col-6">
              <Card title="3. GST Compliance & Litigation" className=" h-full">
                <p className="text-lg mb-2">
                  Goods & Services Tax (GST) has redefined indirect tax compliance in India. We help businesses remain 
                  compliant, avoid ITC disputes, and resolve litigation swiftly.
                </p>
                <ul className="list-none p-0 m-0">
                  <li className="mb-2 flex align-items-start">
                    <i className="pi pi-check-circle text-primary mr-2 mt-1"></i>
                    <span>Registration advisory, HSN/SAC classification, and invoicing compliance</span>
                  </li>
                  <li className="mb-2 flex align-items-start">
                    <i className="pi pi-check-circle text-primary mr-2 mt-1"></i>
                    <span>Filing of GSTR-1, GSTR-3B, GSTR-9, and 9C</span>
                  </li>
                  <li className="mb-2 flex align-items-start">
                    <i className="pi pi-check-circle text-primary mr-2 mt-1"></i>
                    <span>ITC eligibility reviews, reversals, and blocked credit analysis</span>
                  </li>
                  <li className="mb-2 flex align-items-start">
                    <i className="pi pi-check-circle text-primary mr-2 mt-1"></i>
                    <span>Assistance in audits, departmental queries, and appellate litigation</span>
                  </li>
                  <li className="mb-2 flex align-items-start">
                    <i className="pi pi-check-circle text-primary mr-2 mt-1"></i>
                    <span>E-invoicing, e-way bill, RCM applicability, and industry-specific GST advisory</span>
                  </li>
                  <li className="mb-2 flex align-items-start">
                    <i className="pi pi-check-circle text-primary mr-2 mt-1"></i>
                    <span>Our GST experts offer both routine compliance and strategic dispute resolution services under one roof.</span>
                  </li>
                </ul>
              </Card>
            </div>

            {/* Service 4 */}
            <div className="col-12 md:col-6">
              <Card title="4. Transfer Pricing" className="mb-4">
                <div className="grid">
                  <div className="col-12 gap-2">
                    <p className="text-lg mb-4">
                      Transfer pricing continues to be a major source of tax litigation, especially for MNCs and Indian 
                      entities with related party transactions. We provide:
                    </p>
                    <ul className="list-none p-0 m-0 gap-2">
                      <li className="mb-2 flex align-items-start">
                        <i className="pi pi-check-circle text-primary mr-2 mt-1"></i>
                        <span>Transfer pricing study reports and benchmarking analyses</span>
                      </li>
                      <li className="mb-2 flex align-items-start">
                        <i className="pi pi-check-circle text-primary mr-2 mt-1"></i>
                        <span>Functional, asset, and risk (FAR) profiling</span>
                      </li>
                      <li className="mb-2 flex align-items-start">
                        <i className="pi pi-check-circle text-primary mr-2 mt-1"></i>
                        <span>Documentation under Rule 10D, Form 3CEB filing</span>
                      </li>
                      <li className="mb-2 flex align-items-start">
                        <i className="pi pi-check-circle text-primary mr-2 mt-1"></i>
                        <span>Support in APA, MAP, or Safe Harbour applications</span>
                      </li>
                      <li className="mb-2 flex align-items-start">
                        <i className="pi pi-check-circle text-primary mr-2 mt-1"></i>
                        <span>TP litigation strategy and representation</span>
                      </li>
                      <li className="mb-2 flex align-items-start">
                        <i className="pi pi-check-circle text-primary mr-2 mt-1"></i>
                        <span> We blend global best practices with local law insights to ensure robust, defendable TP documentation.</span>
                      </li>
                    </ul>
                  </div>
                
                </div>
              </Card>
            </div>
          </div>
        </div>

        {/* Closing Section */}
        <div className="col-12 mt-5">
          <Card className="surface-100">
            <h2 className="mt-0">Transform Tax from Burden to Advantage</h2>
            <Divider />
            <p className="text-xl line-height-3">
              With SnP Finvisors' Tax Advisory, tax no longer remains a compliance burden — it becomes a strategic advantage. 
              Let us help you unlock efficiency, minimize disputes, and stay ahead of the tax curve.
            </p>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default TaxAdvisory;